import { Injectable } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';
import { CommentService } from '../../api/services/comment.service';
import { Comment } from '../../api/models/comment';

@Injectable()
export class CommentsAdapterService {

  private universalObjectString: string;

  constructor(private commentService: CommentService, private authService: AuthService) { }

  createComment(body: string, isInternal: boolean, parentCommentId: string = null, fileIds: string[] = [], commentType: string = '') {
    const newComment: Comment = {
      universalObjectString: this.universalObjectString,
      body: body,
      commenterUserId: this.authService.getUserId(),
      parentCommentId: parentCommentId,
      isInternalOnly: isInternal,
      fileIds: fileIds,
      commentType: commentType
    };

    return this.commentService.createComment(newComment);
  }

  getCommentsTree(universalObjectString: string, isTesscoAdmin?:boolean) {
    // this instance of the comments adapter will deal from
    // this point on with that specific universal object
    this.universalObjectString = universalObjectString;

    return this.commentService.getComments(universalObjectString)
    .map(comments => {
      const parents: Comment[] = [];
      const children: Comment[] = [];
      const grandchildren: Comment[] = [];

      if (!comments.length) {
        return [];
      } else {
        comments.map(comment => {
          comment.canEditOrDelete = isTesscoAdmin || comment.commenterUserId === this.authService.getUserId();
        });

        comments.forEach(c => {
          if (c.parentCommentId === null) {
            parents.push(c);
          } else {
            // could be a grandchildren as well but at this point there is no way to tell
            children.push(c);
          }
        });

       children.forEach(c => {
         const parent = parents.find(p => p.id === c.parentCommentId);
         if (parent) {
           parent.comments ? parent.comments.push(c) : parent.comments = [c];
         } else {
           grandchildren.push(c);
         }
       });

       grandchildren.forEach(g => {
        const parent = children.find(c => c.id === g.parentCommentId);
        if (parent) {
          parent.comments ? parent.comments.push(g) : parent.comments = [g];
        }
       });

       return parents;
      }
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/comments-adapter.service.ts